import {
  Avatar,
  Button,
  Card,
  Carousel,
  Divider,
  Image,
  Input,
  List,
  message,
  Row,
  Typography,
} from 'antd';
import React from 'react';

import {
  IoChatboxEllipses,
  IoChatboxEllipsesOutline,
  IoHeart,
  IoHeartOutline,
  IoPencil,
  IoSendSharp,
  IoStar,
  IoStarOutline,
  IoTrash,
} from 'react-icons/io5';
import { getToken, POST_API, POST_CATCH } from '../../services/api';

class TimelineComponent extends React.Component {
  state = {
    comment: false,
    body: '',
  };

  onActionLike = () => {
    const { item, onRenderDataPublicacoesLoad } = this.props;
    POST_API('/timeline/like.php', {
      token: getToken(),
      TYPELIKE: 'LIKE',
      ID: item.ID,
      TYPE: item.SELF_LIKE === '0' ? 'LIKE' : 'UNLIKE',
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          onRenderDataPublicacoesLoad();
        } else {
          message.warning(res.msg);
        }
      })
      .catch(() => {
        POST_CATCH();
      });
  };

  onActionLove = () => {
    const { item, onRenderDataPublicacoesLoad } = this.props;
    POST_API('/timeline/like.php', {
      token: getToken(),
      TYPELIKE: 'LOVE',
      ID: item.ID,
      TYPE: item.SELF_LOVE === '0' ? 'LIKE' : 'UNLIKE',
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          onRenderDataPublicacoesLoad();
        } else {
          message.warning(res.msg);
        }
      })
      .catch(() => {
        POST_CATCH();
      });
  };

  onComment = () => {
    this.setState({ comment: !this.state.comment });
  };

  onCommentSend = () => {
    const { item, onRenderDataPublicacoesLoad } = this.props;

    if (this.state.body === '') {
      message.warning('Digite seu comentário');
    } else {
      POST_API('/timeline_comment/save.php', {
        token: getToken(),
        master: JSON.stringify({ TIMELINE_ID: item.ID, BODY: this.state.body }),
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            this.setState({ body: '' });
            onRenderDataPublicacoesLoad();
          } else {
            message.warning(res.msg);
          }
        })
        .catch(() => {
          POST_CATCH();
        });
    }
  };

  render = () => {
    const { item, index, openModalPublicacoes, onActionPublicacoes, type } =
      this.props;

    return (
      <>
        <Card
          actions={[
            <Button
              className="btn-link"
              key={'like'}
              onClick={this.onActionLike}
              title="Like"
              type="link"
            >
              {item.SELF_LIKE === '0' ? (
                <IoStarOutline style={{ marginRight: 5 }} />
              ) : (
                <IoStar color="var(--primary)" style={{ marginRight: 5 }} />
              )}
              {item.LIKE_QTDE}
            </Button>,
            <Button
              className="btn-link"
              key="amei"
              onClick={this.onActionLove}
              title="Amei"
              type="link"
            >
              {item.SELF_LOVE === '0' ? (
                <IoHeartOutline style={{ marginRight: 5 }} />
              ) : (
                <IoHeart color="var(--primary)" style={{ marginRight: 5 }} />
              )}
              {item.LOVE_QTDE}
            </Button>,
            <Button
              className="btn-link"
              key="comment"
              onClick={this.onComment}
              title="Comentários"
              type="link"
            >
              {this.state.comment ? (
                <IoChatboxEllipses
                  color="var(--primary)"
                  style={{ marginRight: 5 }}
                />
              ) : (
                <IoChatboxEllipsesOutline style={{ marginRight: 5 }} />
              )}
              {item.COMMENT_QTDE}
            </Button>,
          ]}
          cover={
            item.PHOTOS.length > 0 ? (
              <Carousel className="timelineA-carousel">
                {item.PHOTOS.map((v) => (
                  <div className="timeline-carousel" key={v.ID}>
                    <Image preview={false} src={v.URL} />
                  </div>
                ))}
              </Carousel>
            ) : null
          }
          size="small"
          title={
            <List>
              <List.Item
                actions={
                  type === 'list'
                    ? []
                    : [
                        <Button
                          className="table__btn table__btn_edit"
                          key="editar"
                          onClick={() => openModalPublicacoes('edit', item)}
                          shape="circle"
                          size="small"
                          title="Editar"
                          type="primary"
                        >
                          <IoPencil size={14} />
                        </Button>,
                        <Button
                          className="table__btn table__btn_delete"
                          key="deletar"
                          onClick={() =>
                            onActionPublicacoes(
                              item.ID,
                              'del',
                              'Excluir registro?'
                            )
                          }
                          shape="circle"
                          size="small"
                          title="Excluir"
                          type="primary"
                        >
                          <IoTrash size={14} />
                        </Button>,
                      ]
                }
                key={index}
              >
                <List.Item.Meta
                  avatar={<Avatar size={30} src={item.CREDENTIAL_AVATAR} />}
                  title={
                    <Typography
                      style={{
                        marginTop: 3,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {item.CREDENTIAL_NAME}
                    </Typography>
                  }
                />
              </List.Item>
            </List>
          }
        >
          <Typography className="timeline-title">{item.NAME}</Typography>
          <Typography className="timeline-text">{item.DESC}</Typography>
          <Typography className="timeline-date">
            Publicado em {item.DATETIME_INSERT_FORMAT}
          </Typography>
        </Card>
        {this.state.comment ? (
          <Card style={{ marginTop: 10 }}>
            <Row align={'bottom'} justify={'space-between'}>
              <Input.TextArea
                onChange={(v) => this.setState({ body: v.target.value })}
                placeholder="Deixe seu comentário..."
                style={{ width: '90%' }}
                value={this.state.body}
              />
              <Button
                className="btn-link"
                onClick={this.onCommentSend}
                shape="circle"
                style={{ width: '8%' }}
                type="link"
              >
                <IoSendSharp />
              </Button>
            </Row>
            <Divider />
            {item.COMMENT_QTDE > 0 ? (
              <List
                dataSource={item.COMMENTS}
                itemLayout="horizontal"
                renderItem={(comment, i) => (
                  <List.Item key={i}>
                    <List.Item.Meta
                      avatar={<Avatar src={comment.CREDENTIAL_AVATAR} />}
                      description={comment.BODY}
                      title={<Typography>{comment.CREDENTIAL_NAME}</Typography>}
                    />
                  </List.Item>
                )}
              />
            ) : (
              <Typography
                style={{
                  textTransform: 'uppercase',
                  color: '#0000008c',
                  textAlign: 'center',
                  fontSize: 10,
                }}
              >
                Seja o primeiro a comentar
              </Typography>
            )}
          </Card>
        ) : null}
      </>
    );
  };
}

export default TimelineComponent;
